<template>
  <span>
    <span class="c-color--yellow">
      {{ '★' | repeatText(score) }}
    </span>
    <!-- 一般的なSEO課題 -->
    <template v-if="proposal.content === 'MetaTitle'">
      メタタイトルタグを変更してページ評価を改善しましょう！
    </template>
    <template v-else-if="proposal.content === 'MetaDescription'">
      メタディスクリプションタグを変更してページ評価を改善しましょう！
    </template>
    <template v-else-if="proposal.content === 'Heading'">
      見出しタグを追加してページ評価を改善しましょう！
    </template>
    <template v-else-if="proposal.content === 'HasRobot'">
      robots.txtを設置してページ評価を改善しましょう！
    </template>
    <template v-else-if="proposal.content === 'HasSiteMap'">
      サイトマップを設置してページ評価を改善しましょう！
    </template>
    <template v-else-if="proposal.content === 'BrokenLink'">
      壊れたリンクを修正してページ評価を改善しましょう！
    </template>
    <template v-else-if="proposal.content === 'BrokenImageLink'">
      画像のリンク切れを解消してページ評価を改善しましょう！
    </template>
    <template v-else-if="proposal.content === 'BrokenStylesheetLink'">
      CSSのリンク切れを解消してページ評価を改善しましょう！
    </template>
    <template v-else-if="proposal.content === 'BrokenScriptLink'">
      JavaScriptのリンク切れを解消してページ評価を改善しましょう！
    </template>
    <template v-else-if="proposal.content === 'CheckAlt'">
      画像タグにalt属性を設定してページ評価を改善しましょう！
    </template>
    <template v-else-if="proposal.content === 'DeprecatedHtmlTag'">
      非推奨HTMLタグを修正してページ評価を改善しましょう！
    </template>
    <template v-else-if="proposal.content === 'Favicon'">
      Webサイトにファビコンを設定してページ評価を改善しましょう！
    </template>
    <template v-else-if="proposal.content === 'JsError'">
      エラーが発生しているJavaScriptを修正してページ評価を改善しましょう！
    </template>
    <template v-else-if="proposal.content === 'LinkSns'">
      ソーシャルメディアへのリンクを設置してページ評価を改善しましょう！
    </template>
    <!-- スピード最適化 -->
    <template v-else-if="proposal.content === 'HtmlSize'">
      HTMLのページサイズを改善して表示速度を改善しましょう！
    </template>
    <template v-else-if="proposal.content === 'CompressedHtml'">
      HTMLを圧縮してページ評価を改善しましょう！
    </template>
    <template v-else-if="proposal.content === 'SiteLoadingSpeedDesktop'">
      PCサイトの読み込み速度を改善して表示速度を改善しましょう！
    </template>
    <template v-else-if="proposal.content === 'SiteLoadingSpeedMobile'">
      MOBILEサイトの読み込み速度を改善して表示速度を改善しましょう！
    </template>
    <template v-else-if="proposal.content === 'OutBoundLink'">
      外部参照ファイル数を改善して表示速度を改善しましょう！
    </template>
    <template v-else-if="proposal.content === 'PageCache'">
      ページキャッシュを有効にして表示速度を改善しましょう！
    </template>
    <template v-else-if="proposal.content === 'UseFlash'">
      Flashタグが設置されているコンテンツを修正してページ評価を改善しましょう！
    </template>
    <template v-else-if="proposal.content === 'ImageCache'">
      画像キャッシュを有効にして表示速度を改善しましょう！
    </template>
    <template v-else-if="proposal.content === 'JsCache'">
      JavaScriptのキャッシュを有効にして示速度を改善しましょう！
    </template>
    <template v-else-if="proposal.content === 'CssCache'">
      CSSのキャッシュを有効にして表示速度を改善しましょう！
    </template>
    <template v-else-if="proposal.content === 'JsMinify'">
      JavaScriptを縮小して表示速度を改善しましょう！
    </template>
    <template v-else-if="proposal.content === 'CssMinify'">
      CSSを縮小して表示速度を改善しましょう！
    </template>
    <template v-else-if="proposal.content === 'NestTable'">
      ネストされたテーブルタグを修正して表示速度を改善しましょう！
    </template>
    <template v-else-if="proposal.content === 'UseFrame'">
      frameタグが設置されているコンテンツを修正してページ評価を改善しましょう！
    </template>
    <template v-else-if="proposal.content === 'Docktype'">
      Doctype宣言を正しく記述してページ評価を改善しましょう！
    </template>
    <template v-else-if="proposal.content === 'UrlRedirect'">
      ページのリダイレクト設定を修正してページ評価を改善しましょう！
    </template>
    <!-- サーバー&セキュリテイ -->
    <template v-else-if="proposal.content === 'NormalizationUrl'">
      URLを正規化してページ評価を改善しましょう！
    </template>
    <template v-else-if="proposal.content === 'HttpsCheck'">
      ページのHTTPS化を行いセキュリティ評価を改善しましょう！
    </template>
    <template v-else-if="proposal.content === 'ServerSignature'">
      サーバー署名機能をオフにしてセキュリティ評価を改善しましょう！
    </template>
    <template v-else-if="proposal.content === 'DirectoryBrowsing'">
      サーバーのディレクトリ参照を無効にしてセキュリティ評価を改善しましょう！
    </template>
    <template v-else-if="proposal.content === 'Email'">
      html内のメールアドレス形式の文字列を修正してセキュリティ評価を改善しましょう！
    </template>
    <!-- モバイルユーザビリティ -->
    <template v-else-if="proposal.content === 'MediaQuery'">
      メディアクエリを使用してページのモバイルユーザービリティを改善しましょう！
    </template>
    <!-- 高度なSEO -->
    <template v-else-if="proposal.content === 'StructuredData'">
      構造化データをマークアップしてページ評価を改善しましょう！
    </template>
    <template v-else-if="proposal.content === 'CanonicalCheck'">
      canonicalタグの設置を行い、URLの正規化しページ評価を改善しましょう！
    </template>
    <template v-else-if="proposal.content === 'CrawlAvoidance'">
      robots.txtにクロール回避の指示を記入しましょう！
    </template>
    <template v-else-if="proposal.content === 'UseHttp2'">
      WebサイトのHttp2対応を行いページ評価を改善しましょう！
    </template>
    <template v-else-if="proposal.content === 'NoIndexCheck'">
      ページに意図していないnoindex設定が行われていないかチェックしましょう！
    </template>
    <template v-else-if="proposal.content === 'NoFollowCheck'">
      ページ内に設置されているリンクに意図していないnofollow属性の設定がないかチェックしましょう！
    </template>
  </span>
</template>
<script>
import { SEO_CHECKUP_ITEM } from '@/constants';
export default {
  props: ['proposal'],
  computed: {
    score() {
      const item = SEO_CHECKUP_ITEM[this.proposal.content];
      if (item && item.score) {
        return item.score;
      }
      return null;
    }
  }
};
</script>
